import { render, staticRenderFns } from "./HistoryPublishedList.vue?vue&type=template&id=28088b9b&"
import script from "./HistoryPublishedList.vue?vue&type=script&setup=true&lang=js&"
export * from "./HistoryPublishedList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports